module.exports = __webpack_public_path__ + "img/function.ad5519c5.png";